var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 0A5.506 5.506 0 000 5.5C0 8.533 2.467 11 5.5 11S11 8.533 11 5.5 8.533 0 5.5 0zm2.494 6.26H5.392l-.016-.002-.015.001a.465.465 0 01-.465-.465v-3.78a.465.465 0 01.93 0V5.33h2.168a.465.465 0 110 .93z"}));
}

Clock.defaultProps = {"fill":"currentColor","viewBox":"0 0 11 11"};

module.exports = Clock;

Clock.default = Clock;
